import React__default, { memo, useMemo } from 'react';
import { useTheme } from '@mui/material';
import 'lodash/isEqual';
import '../../node_modules/tslib/tslib.es6.js';
import 'lodash/get';
import 'lodash/orderBy';
import '@splitsoftware/splitio-react';
import { useConversationStarters } from '../../utils/hooks/useConversationStarters.js';
import { wrapSearchWithProductContext } from '../utils/wrapSearchWithProductContext.js';
import { TextBox } from '@brandclub/bc-widgets';

const ConciergeWelcomeEmbeddedComponent = ({ displayQueries, isLoadingSuggestedQueries, onSearch, pageContext, }) => {
    const theme = useTheme();
    const pageType = pageContext === null || pageContext === void 0 ? void 0 : pageContext.pageType;
    const stacklineSku = pageContext === null || pageContext === void 0 ? void 0 : pageContext.stacklineSku;
    // Fetch context-specific queries using the shared hook
    const { questions: contextQueries, isLoading: isLoadingContextQueries } = useConversationStarters({
        stacklineSku,
        enabled: pageType === 'pdp' && !!stacklineSku,
    });
    // Use context queries if available, otherwise fall back to displayQueries
    const queriesToShow = useMemo(() => (contextQueries.length > 0 ? contextQueries : displayQueries), [contextQueries, displayQueries]);
    const isLoading = useMemo(() => isLoadingContextQueries || ((pageContext === null || pageContext === void 0 ? void 0 : pageContext.pageType) === 'pdp' && isLoadingSuggestedQueries), [isLoadingContextQueries, pageContext === null || pageContext === void 0 ? void 0 : pageContext.pageType, isLoadingSuggestedQueries]);
    return (React__default.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px 16px',
            textAlign: 'center',
            width: '100%',
            height: '100%',
            boxSizing: 'border-box',
            overflow: 'auto',
        } },
        React__default.createElement("div", { style: { marginBottom: '20px' } },
            React__default.createElement("div", { style: { margin: '0 0 8px 0' } },
                React__default.createElement(TextBox, { widgetId: "concierge-welcome-message", displayName: "Welcome Message", initialState: {
                        content: "Let us help you find what you've been looking for.",
                        fontSize: 24,
                        fontWeight: 'bold',
                        color: '#031425',
                        textAlign: 'center',
                        lineHeight: 1.2,
                        letterSpacing: 0,
                        textTransform: 'none',
                    } }))),
        queriesToShow.length > 0 && !isLoading && (React__default.createElement("div", { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                maxWidth: '100%',
            } }, queriesToShow.slice(0, 4).map((query, index) => (React__default.createElement("button", { key: index, onClick: () => {
                // Wrap query with product context if on a PDP
                const queryWithContext = wrapSearchWithProductContext(query, pageContext);
                onSearch(queryWithContext);
            }, style: {
                padding: '12px 16px',
                borderRadius: '8px',
                border: `1px solid ${theme.palette.divider}`,
                backgroundColor: 'transparent',
                color: theme.palette.text.primary,
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                textAlign: 'left',
                transition: 'all 0.2s ease',
                width: '100%',
            }, onMouseEnter: (e) => {
                e.currentTarget.style.backgroundColor = theme.palette.action.hover;
            }, onMouseLeave: (e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
            } }, query)))))));
};
// Memoize to prevent re-renders when parent re-renders due to input changes
const ConciergeWelcomeEmbedded = memo(ConciergeWelcomeEmbeddedComponent);

export { ConciergeWelcomeEmbedded };
//# sourceMappingURL=ConciergeWelcomeEmbedded.js.map
